<!--
/**
* @name: Detail.vue
* @description: 门店陈列活动-详情页
* @author: 杨波
* @create: 2020/05/19 11:40:37
* @update: 2020/05/19 11:40:37
*/
-->
<template>
  <y-view :loading="isLoading" title="基本信息">
    <template v-if="showType === 0">
      <y-form titleAlign="right" align="center" titleWidth="80px" contentWidth="400px">
        <y-form-item title="活动名称:" required>
          <k-input placeholder="请输入活动名称" maxlength="30" block v-model="editPara.activityName" clearable></k-input>
        </y-form-item>
        <y-form-item title="有效时间:" required>
          <DatePicker :editable="false" ref="DatePicker" type="datetimerange" @on-change="changeDate" :value="validityTime" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"></DatePicker>
        </y-form-item>
        <y-form-item title="宣传图:" align="top" required>
          <div class="row">
            <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="(e) => this.handleUploaded(e, 1)" v-if="!editPara.shareImage"></y-upload-file>
            <y-image v-else @delete="onDeletePic(1)" :src="editPara.shareImage"></y-image>
          </div>
          <div class="mt-1" style="color: #bfbfbf;">图片支持png，jpeg，jpg格式。尺寸为750*396像素。</div>
        </y-form-item>
        <y-form-item title="示例图:" align="top" required>
          <div class="row">
            <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="(e) => this.handleUploaded(e, 2)" v-if="!editPara.demoImages"></y-upload-file>
            <y-image v-else @delete="onDeletePic(2)" :src="editPara.demoImages"></y-image>
          </div>
          <div class="mt-1" style="color: #bfbfbf;">图片支持png，jpeg，jpg格式。尺寸为207*204像素。</div>
        </y-form-item>
        <y-form-item title="活动说明:" align="top" required>
          <k-input tag="textarea" :class="css.textarea" placeholder="请输入活动说明" maxlength="300" block v-model="editPara.description" clearable></k-input>
        </y-form-item>
      </y-form>
    </template>
    <template v-if="showType === 1">
      <y-form titleAlign="right" align="center" titleWidth="80px" contentWidth="400px">
        <y-form-item title="活动名称:" required>
          <k-input v-if="editPara.status === 'not_start'" placeholder="请输入活动名称" maxlength="30" block v-model="editPara.activityName" clearable></k-input>
          <div v-else :class="css.inputW">{{ editPara.activityName }}</div>
        </y-form-item>
        <y-form-item title="有效时间:" required>
          <DatePicker
            v-if="editPara.status === 'not_start'"
            :editable="false"
            ref="DatePicker"
            type="datetimerange"
            @on-change="changeDate"
            :value="validityTime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择"
          ></DatePicker>
          <div v-else :class="css.inputW">{{ editPara.startTime }} - {{ editPara.endTime }}</div>
        </y-form-item>
        <y-form-item title="宣传图:" align="top" required>
          <div class="row" v-if="editPara.status === 'not_start'">
            <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="(e) => this.handleUploaded(e, 1)" v-if="!editPara.shareImage"></y-upload-file>
            <y-image v-else @delete="onDeletePic(1)" :src="editPara.shareImage"></y-image>
          </div>
          <div class="row" v-else>
            <y-image view :src="editPara.shareImage"></y-image>
          </div>
          <div class="mt-1" style="color: #bfbfbf;">图片支持png，jpeg，jpg格式。尺寸为750*396像素。</div>
        </y-form-item>
        <y-form-item title="示例图:" align="top" required>
          <div class="row">
            <y-upload-file fileType="image" :uploadUrl="uploadUrl" @uploaded="(e) => this.handleUploaded(e, 2)" v-if="!editPara.demoImages"></y-upload-file>
            <y-image v-else @delete="onDeletePic(2)" :src="editPara.demoImages"></y-image>
          </div>
          <div class="mt-1" style="color: #bfbfbf;">图片支持png，jpeg，jpg格式。尺寸为204*204像素。</div>
        </y-form-item>
        <y-form-item title="活动说明:" align="top" required>
          <k-input tag="textarea" :class="css.textarea" placeholder="请输入活动说明" maxlength="300" block v-model="editPara.description" clearable></k-input>
        </y-form-item>
      </y-form>
    </template>
    <template v-if="showType === 2">
      <y-form titleAlign="right" align="center" titleWidth="80px" contentWidth="400px">
        <y-form-item title="活动名称:" required>
          <div :class="css.inputW">{{ editPara.activityName }}</div>
        </y-form-item>
        <y-form-item title="有效时间:" required>
          <div :class="css.inputW">{{ editPara.startTime }}~{{ editPara.endTime }}</div>
        </y-form-item>
        <y-form-item title="宣传图:" align="top" required>
          <y-image view :src="editPara.shareImage"></y-image>
          <div class="mt-1" style="color: #bfbfbf;">图片支持png，jpeg，jpg格式。尺寸为750*396像素。</div>
        </y-form-item>
        <y-form-item title="示例图:" align="top" required>
          <y-image view :src="editPara.demoImages"></y-image>
          <div class="mt-1" style="color: #bfbfbf;">图片支持png，jpeg，jpg格式。尺寸为204*204像素。</div>
        </y-form-item>
        <y-form-item title="活动说明:" align="top" required>
          <div :class="css.inputW">{{ editPara.description }}</div>
        </y-form-item>
      </y-form>
    </template>
    <div slot="bottom">
      <k-button @click="onCancel(true, false)">取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus" v-if="showType != 2">保存</k-button>
    </div>
  </y-view>
</template>
<script>
import {
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
  NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_CREATE,
  NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_UPDATE,
  NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_DETAIL,
} from "@/assets/modules/apiList";
const initEditPara = () => ({
  id: "", //活动ID
  activityName: "", //活动名称
  startTime: "", //开始时间
  endTime: "", //结束时间
  shareImage: "", //宣传图
  demoImages: "", //示例图
  description: "", //活动说明
  isEnabled: true, //启停用状态
});
export default {
  data() {
    return {
      isLoading: false,
      isSaving: false,
      showType: 0,
      validityTime: "",
      editPara: initEditPara(),
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
    };
  },
  filters: {},
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (this.showType < 2) {
        if (!para.activityName || !this.validityTime || !para.shareImage || !para.demoImages || !para.description) {
          status = true;
        }
      }
      return status;
    },
  },
  watch: {},
  methods: {
    /** 获取门店陈列活动信息详情 */
    getActivityDetail(id) {
      this.isLoading = true;
      this.$fetch({ api: NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_DETAIL, para: { id: id } })
        .then(async (res) => {
          this.editPara = { ...this.editPara, ...res };
          this.validityTime = [this.editPara.startTime, this.editPara.endTime];
          this.isLoading = false;
          this.$forceUpdate();
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    /** 返回门店陈列活动列表 */
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "exhibitManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },

    /** 上传宣传图、示例图 */
    handleUploaded(data, type) {
      // type 1.宣传图 2.示例图
      switch (type) {
        case 1:
          this.editPara.shareImage = data.data[0].url;
          break;
        default:
          this.editPara.demoImages = data.data[0].url;
          break;
      }
    },

    /** 删除宣传图、示例图 */
    onDeletePic(type) {
      // type 1.宣传图 2.示例图
      this.$dialog({
        title: "提示",
        content: `${type === 1 ? "是否确认删除宣传图？" : "是否确认删除示例图？"}`,
        ok: () => {
          switch (type) {
            case 1:
              this.editPara.shareImage = "";
              break;
            default:
              this.editPara.demoImages = "";
              break;
          }
        },
      });
    },

    changeDate(time) {
      this.validityTime = time;
      if (time.length && time[0] && time[1]) {
        // 没有选择时间就默认23:59:59
        if (this.validityTime[1].slice(-8) === "00:00:00") {
          this.validityTime[1] = this.validityTime[1].replace(this.validityTime[1].substring(11, 19), "23:59:59");
        }
      }
      this.$refs["DatePicker"].internalValue = this.validityTime;
    },

    /** 保存门店陈列活动信息 */
    onSave() {
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      para.startTime = this.validityTime && this.validityTime.length > 0 ? this.validityTime[0] : "";
      para.endTime = this.validityTime && this.validityTime.length > 0 ? this.validityTime[1] : "";
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.showType === 1 ? NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_UPDATE : NESTLE_MARKETING_BACK_SERVER_DISPLAY_ACTIVITY_CREATE,
        para,
      })
        .then(() => {
          this.isSaving = false;
          this.isLoading = false;
          this.$root.tip("操作成功");
          this.onCancel(true, true);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
  },
  async created() {
    const { id, showType } = this.$route.query;
    this.validityTime = "";
    this.editPara = initEditPara();
    this.showType = parseInt(showType);
    if (id) this.getActivityDetail(id);
  },

  beforeRouteUpdate(to, from, next) {
    const { id, showType } = to.query;
    this.validityTime = "";
    this.editPara = initEditPara();
    this.showType = parseInt(showType);
    if (id) this.getActivityDetail(id);
    next();
  },
};
</script>
<style module="css" lang="postcss">
.inputW {
  width: 400px !important;
}

.textarea {
  width: 400px !important;
  height: 150px;
  & :global(.k-textarea) {
    height: 150px !important;
    resize: none;
  }
}
</style>
